/**
 * "Add to portfolio" for a coaching result.
 *
 * POST /portfolio/me/highlights/from-result creates the owner's portfolio item
 * PRIVATE (isPublic=false). Publishing is the existing per-item control
 * (upsertHighlight with isPublic), on the result view or the Portfolio page.
 * Neither makes the profile public nor touches talent discovery.
 *
 * The mutation is injected here and its tags are attached with
 * enhanceEndpoints from this module only (the shared api.ts tag list is not
 * edited): adding an item refreshes the highlight list.
 */

import { api } from '../api';
import type { PortfolioHighlight } from './portfolioApi';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const portfolioResultApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addResultToPortfolio: builder.mutation<PortfolioHighlight, { sessionId: string; title?: string }>({
      query: (body) => ({ url: '/portfolio/me/highlights/from-result', method: 'POST', body }),
      transformResponse: (r: ApiResponse<PortfolioHighlight>) => r.data,
    }),
  }),
});

type TagList = unknown[];
interface Enhanceable {
  enhanceEndpoints(options: {
    endpoints?: Record<string, (definition: { invalidatesTags?: TagList }) => void>;
  }): unknown;
}

(portfolioResultApi as unknown as Enhanceable).enhanceEndpoints({
  endpoints: {
    addResultToPortfolio: (d) => {
      if (d) d.invalidatesTags = ['Highlights'];
    },
  },
});

export const { useAddResultToPortfolioMutation } = portfolioResultApi;
